<template>
	<tbody>
		<tr>
			<td colspan="99">
				<base-loader></base-loader>
			</td>
		</tr>
	</tbody>
</template>

<script>
import BaseLoader from '../BaseLoader.vue';
export default {
	components:{
		BaseLoader
	}
}
</script>